/* Rs 99 Store: cap of 1 pair per cart + Rs 450 shipping nudge. Guards Add to Cart on Rs 99 products (PDP form and grid quick-add).
   Counts Rs 99 lines in /cart.js (Shopflo adds land in the Shopify cart). Fails open if the cart read fails.
   Nudge: NUDGE_MS after the first allowed Rs 99 add, once per browser session, only while the cart holds Rs 99 items and nothing else. */
(function () {
  var CAP = 1, PRICE = 9900;
  var HEAD = 'Whoa, easy there!', BODY = 'Only 1 pair per order on the Rs 99 Store.';
  var CAP_NOTE = 'Add any regular-price pair from Shop All and skip the Rs 450 shipping fee.';
  var FEE_HEAD = "You're about to pay Rs 450 shipping", FEE_BODY = 'Check out some of our regular-price styles to get Free Shipping.';
  var NUDGE_MS = 9000, KEY = 'pt_rs99_t0', SHOWN = 'pt_rs99_nudged', armed = false;
  var IMG = '//www.pairietales.com/cdn/shop/files/2026-09-09_flats_grid_separator_revised_1396x1042_8055371f-93b1-4243-b70c-ff4a2eb1dd8a.png?width=680';

  var CSS = '#pt-rs99-pop{position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(18,18,18,.55);opacity:0;transition:opacity .25s ease;font-family:Montserrat,sans-serif;overflow-y:auto;overscroll-behavior:contain}' +
    '#pt-rs99-pop.on{opacity:1}' +
    '#pt-rs99-pop .c{position:relative;width:100%;max-width:340px;margin:auto;padding:0 0 22px;max-height:92vh;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;background:#121212;color:#fff;border-radius:12px;text-align:center;box-shadow:0 16px 48px rgba(0,0,0,.4);transform:scale(.8) translateY(16px);opacity:0;transition:transform .45s cubic-bezier(.34,1.56,.64,1),opacity .25s ease}' +
    '#pt-rs99-pop.on .c{transform:none;opacity:1}' +
    '#pt-rs99-pop img{display:block;width:100%;aspect-ratio:1/1;object-fit:cover;object-position:0% 50%;margin:0 0 18px}' +
    '#pt-rs99-pop h3{margin:0 24px 8px;font:700 20px/1.25 Montserrat,sans-serif;color:#CADB2A}' +
    '#pt-rs99-pop p{margin:0 24px 8px;font:500 14px/1.5 Montserrat,sans-serif;color:#fff}' +
    '#pt-rs99-pop p.n{margin-bottom:20px;color:#ddd}' +
    '#pt-rs99-pop a.go{display:block;margin:12px 24px 8px;padding:12px;border-radius:6px;background:#CADB2A;color:#121212;font:700 13px/1 Montserrat,sans-serif;letter-spacing:.08em;text-transform:uppercase;text-decoration:none}' +
    '#pt-rs99-pop button{width:calc(100% - 48px);padding:10px;border:0;background:none;color:#fff;font:500 12px/1 Montserrat,sans-serif;text-decoration:underline;cursor:pointer}' +
    '@media (prefers-reduced-motion:reduce){#pt-rs99-pop,#pt-rs99-pop .c{transition:none}}';

  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) {}
    return null;
  }

  function hide() {
    var t = document.getElementById('pt-rs99-pop');
    if (!t) return;
    clearTimeout(t._h);
    t.classList.remove('on');
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 300);
  }

  function toast(head, body, note) {
    var t = document.getElementById('pt-rs99-pop');
    if (t) t.parentNode.removeChild(t);
    if (!document.getElementById('pt-rs99-css')) {
      var st = document.createElement('style');
      st.id = 'pt-rs99-css';
      st.textContent = CSS;
      document.head.appendChild(st);
    }
    t = document.createElement('div');
    t.id = 'pt-rs99-pop';
    t.setAttribute('role', 'alertdialog');
    t.setAttribute('aria-label', head + ' ' + body);
    t.innerHTML = '<div class="c"><img alt="" src="' + IMG + '"><h3></h3><p></p><p class="n"></p><a class="go" href="/collections/all">Shop all styles</a><button type="button">Not now</button></div>';
    t.querySelector('h3').textContent = head;
    t.querySelector('p').textContent = body;
    var n = t.querySelector('p.n');
    if (note) n.textContent = note; else n.parentNode.removeChild(n);
    t.addEventListener('click', function (e) { if (e.target === t || e.target.tagName === 'BUTTON') hide(); });
    document.body.appendChild(t);
    void t.offsetWidth;
    t.classList.add('on');
  }

  function capToast() { toast(HEAD, BODY, CAP_NOTE); }

  /* cb({rs99: units at Rs 99, other: units at any other price}); a failed read reports an empty cart */
  function cartCounts(cb) {
    var x = new XMLHttpRequest();
    x.open('GET', '/cart.js', true);
    x.onload = function () {
      try {
        var c = { rs99: 0, other: 0 };
        JSON.parse(x.responseText).items.forEach(function (i) { if (i.original_price === PRICE) c.rs99 += i.quantity; else c.other += i.quantity; });
        cb(c);
      } catch (e) { cb({ rs99: 0, other: 0 }); }
    };
    x.onerror = function () { cb({ rs99: 0, other: 0 }); };
    x.send();
  }

  function rs99InCart(cb) { cartCounts(function (c) { cb(c.rs99); }); }

  /* Fee nudge: once per session, NUDGE_MS after the first allowed Rs 99 add, only if the cart is still Rs 99 only. */
  function armNudge() {
    var t0 = parseInt(ss(KEY), 10);
    if (!t0 || ss(SHOWN) || armed) return;
    armed = true;
    setTimeout(function () {
      if (ss(SHOWN)) return;
      cartCounts(function (c) {
        if (c.rs99 > 0 && c.other === 0 && !ss(SHOWN)) { ss(SHOWN, '1'); toast(FEE_HEAD, FEE_BODY); }
      });
    }, Math.max(0, t0 + NUDGE_MS - Date.now()));
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('.qvm-atc-btn[data-rs99], form[action*="/cart/add"] button[type=submit]');
    if (!btn) return;
    if (btn.__rs99ok) { btn.__rs99ok = false; return; }
    if (btn.disabled) return;
    var qty = 1;
    if (btn.form) {
      if (!document.querySelector('[data-rs99-pdp]')) return;
      var q = btn.form.querySelector('input[name=quantity]');
      if (q) qty = parseInt(q.value, 10) || 1;
    }
    e.preventDefault(); e.stopImmediatePropagation();
    if (qty > CAP) { capToast(); return; }
    rs99InCart(function (n) {
      if (n + qty > CAP) { capToast(); return; }
      if (!ss(KEY)) ss(KEY, String(Date.now()));
      armNudge();
      btn.__rs99ok = true;
      btn.click();
    });
  }, true);

  armNudge();
})();
